module.exports = __webpack_public_path__ + "img/logo-2.369a7ce4.png";